import { enumBranchStyle } from "../constants";
import { GetObjectLevel } from "./GetObjectLevel";
import { IsSingleFile } from "./IsSingleFile";

export function DetermineBranchStyleNoChildren(parentDataObj, defaultStyle) {
  // No children so we need to determine the best branch style using the following rules
  //  0. Use defaultStyle if not null
  //	1. If parent is assistant -> one column
  //  2. If Level 2 or Single File -> tree
  //  3. If '> Level 2' -> one column, two column, four column or eight column

  if (defaultStyle != null) return defaultStyle;

  var bStyle = enumBranchStyle.tree;
  var pLevel = GetObjectLevel(parentDataObj); //this.
  if (pLevel == null) return bStyle;

  if (pLevel == 1 || IsSingleFile(parentDataObj)) return bStyle;

  var nc = parentDataObj.GetNumChildren();
  if (pLevel > 2) {
    if (nc > 90) bStyle = enumBranchStyle.twentycolumn;
    else if (nc > 72) bStyle = enumBranchStyle.sixteencolumn;
    else if (nc > 54) bStyle = enumBranchStyle.twelvecolumn;
    else if (nc > 36) bStyle = enumBranchStyle.eightcolumn;
    else if (nc > 24) bStyle = enumBranchStyle.sixcolumn;
    else if (nc > 12) bStyle = enumBranchStyle.fourcolumn;
    else if (nc > 6) bStyle = enumBranchStyle.twocolumn;
    else bStyle = enumBranchStyle.onecolumnright;
  } else {
    if (nc > 90) bStyle = enumBranchStyle.twentycolumn;
    else if (nc > 72) bStyle = enumBranchStyle.sixteencolumn;
    else if (nc > 54) bStyle = enumBranchStyle.twelvecolumn;
    else if (nc > 36) bStyle = enumBranchStyle.eightcolumn;
    else if (nc > 24) bStyle = enumBranchStyle.sixcolumn;
    else if (nc > 8) bStyle = enumBranchStyle.fourcolumn;
    else bStyle = enumBranchStyle.tree;
  }

  return bStyle;
}
